import { graphql } from '@/gql';
import { queryExecute } from '@/Utils/graphqlAPI';

export const getVisitorInformation = async (callerId: string) => {
  const response = await queryExecute({
    fetchPolicy: 'no-cache',
    variables: {
      callerId,
    },
    query: graphql(`
      query GetVisitorInformation($callerId: String!) {
        getVisitorInformation(callerId: $callerId) {
          requestId
          incognito
          url
          ip
          time
          ipLocation
          browserDetails
          ipFullAddress
        }
      }
    `),
  });

  return response.data.getVisitorInformation ?? [];
};
